// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dynamicTable .cell-bg{background-color:#000!important;color:#fff}.dynamicTable .myHtml{white-space:pre-wrap}.dynamicTable .cell-pointer{cursor:pointer}.dynamicTable .cell-pointer:hover{color:#409eff}", ""]);
// Exports
module.exports = exports;
